var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.authenticated)?_c('a',{on:{"click":function($event){return _vm.login()}}},[_vm._v(" Login ")]):_vm._e(),(_vm.authenticated)?_c('a',{on:{"click":function($event){return _vm.logout()}}},[_vm._v(" Logout ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }